<template>
  <div>
  <el-dialog v-loading="loading" title="应用电子投保单" :visible.sync="dialogVisible" top="10px">
    <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%">
      <el-table-column
        property="appform_number"
        label="投保单号"
        width="150">
      </el-table-column>
      <el-table-column
        property="ship_name"
        label="船名"
        width="150">
      </el-table-column>
      <el-table-column
        property="begin_time"
        label="起保日期">
      </el-table-column>
      <el-table-column
        property="end_time"
        label="到期日期">
      </el-table-column>
      <el-table-column
        property="total_insured_premium"
        label="保费（元）">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="previewPdf(scope.row.appform_file)" >预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-button type="primary" style="float: right;" @click="handleAdjust">确定</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="pdfname" :visible.sync="previewVisible">
    <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
  </el-dialog>
  </div>
</template>

<script>
import { fetchElectronic, toForm } from '@/api/form'
import VuePdfPreview from "@/components/VuePdfPreview"

export default {
  name: 'electronic-forms-dialog',
  components: {
    VuePdfPreview
  },
  watch: {
    tableData: function() {
      let res = this.tableData.find(form => form === this.currentRow)
      this.$nextTick(function() {
        this.$refs.singleTable.setCurrentRow(res)
      })
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      app_form: null,
      currentRow: null,
      previewVisible: false,
      pdfname: '',
      pdfUrl: '',
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleOpen(app_form) {
      this.loading = true
      fetchElectronic({'id': app_form.insurance})
      .then(res => {
        this.tableData = res.filter(form => (form.insurance_type==app_form.type_name && form.insurance_company_branch_office==app_form.company_name))
        this.currentRow = this.tableData.find(form => form.id === app_form.electronic)
        this.app_form = app_form
        // console.log('currentRow:', this.currentRow)
        this.loading = false
        this.dialogVisible = true
      })
      .catch(err => {
        this.loading = false
        this.$error_message(err)
      })
    },
    previewPdf(file){
      // window.open(url, 'PDF', '')
      this.pdfname = file.name
      this.pdfUrl = file.url
      this.previewVisible = true
    },
    handleAdjust() {
      if (!this.currentRow) {
        this.$error_message("请选择一个电子投保单")
        return
      }
      else {
        toForm({'id':this.app_form.insurance, 'electronic_id':[this.currentRow.id]})
        .then(resp => {
          this.$message({
            type: 'success',
            message: '切换投保单成功!'
          })
          this.dialogVisible = false
          this.$emit("updateList")
        })
        .catch(error => {
          this.$message.error(error)
          this.dialogVisible = false
        })
      }
    }
  }
}
</script>